import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';

export const organizationName = createSelector(getOrganization, function (organization) {
  if (organization !== undefined) {
    return organization.name;
  } else {
    return '';
  }
});
